import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Loader, Metadata, init } from '@zeedhi/core';
import { normalizeComponent } from 'vue-runtime-helpers';
import Component$1 from 'vue-class-component';
import VueRouter from 'vue-router';
import set from 'lodash.set';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * Zeedhi page component used on routes
 */
var ZdPage = /** @class */ (function (_super) {
    __extends(ZdPage, _super);
    function ZdPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.page = {};
        return _this;
    }
    ZdPage.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, Metadata.get(this.path, this.local)];
                    case 1:
                        _a.page = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ZdPage.prototype.beforeDestroy = function () {
        Loader.clearInstances();
    };
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], ZdPage.prototype, "path", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], ZdPage.prototype, "local", void 0);
    ZdPage = __decorate([
        Component
    ], ZdPage);
    return ZdPage;
}(Vue));

/* script */
const __vue_script__ = ZdPage;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.page.component,
    _vm._b({ tag: "component" }, "component", _vm.page, false)
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * Render
 */
var ZdRender = /** @class */ (function (_super) {
    __extends(ZdRender, _super);
    function ZdRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZdRender.prototype.created = function () {
        var res = Vue.compile("<span>" + this.template + "</span>");
        this.$options.render = res.render;
        this.$options.staticRenderFns = res.staticRenderFns;
    };
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], ZdRender.prototype, "template", void 0);
    ZdRender = __decorate([
        Component$1
    ], ZdRender);
    return ZdRender;
}(Vue));

/**
 * Indirection router class
 */
var Router = /** @class */ (function () {
    function Router() {
    }
    /**
     * Retrieves router object that implements Zeedhi IRouter interface
     * @param instance Router object
     * @returns Router object
     */
    Router.get = function (instance) {
        return instance instanceof VueRouter ? this.getInstance(instance) : instance;
    };
    /**
     * Retrieves router object based on VueRouter instance
     * @param instance VueRouter instance
     * @returns Router object
     */
    Router.getInstance = function (instance) {
        return {
            push: function (location, onComplete, onAbort) {
                instance.push(location, onComplete, onAbort);
            },
            replace: function (location, onComplete, onAbort) {
                instance.replace(location, onComplete, onAbort);
            },
            back: function () { return instance.back(); },
            getCurrentRoute: function () { return instance.currentRoute; },
            getPath: function () { return instance.currentRoute.path; },
            getHash: function () { return instance.currentRoute.hash; },
            getQuery: function () { return instance.currentRoute.query; },
            getParams: function () { return instance.currentRoute.params; },
            getFullPath: function () { return instance.currentRoute.fullPath; },
        };
    };
    return Router;
}());

/**
 * Saves payload in store
 * @param state Vuex state
 * @param param1 Payload
 */
function save(state, _a) {
    var path = _a.path, value = _a.value;
    set(state, path, value);
}

// tslint:disable: variable-name
var VueTheMask = require('@rj-pkgs/vue-the-mask');
var Zeedhi = {
    install: function (Vue, options) {
        if (options === void 0) { options = {}; }
        options.router = options.router && Router.get(options.router);
        init(options);
        Vue.use(VueTheMask.default);
    },
};

export default Zeedhi;
export { __vue_component__ as ZdPage, ZdRender, save };
